import {
    defineNuxtRouteMiddleware,
    navigateTo,
  } from 'nuxt/app';
  import { useIntakeAuthStore } from '../stores/useIntakeAuthStore';
  
  export default defineNuxtRouteMiddleware(() => {
    const { isAdvisor, isLoading } = toRefs(useIntakeAuthStore());
  
    if (!isLoading.value && isAdvisor.value) {
      return navigateTo({ path: '/' });
    }
  });
  